import React, { useContext, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperComponent from 'swiper'
import SvgRightArrowNoBar from '../../icons/SvgRightArrowNoBar'
import { WHITE } from '../../theme'
import { makeStyles } from 'tss-react/mui'
import { directionEnum } from './enums/directionEnum'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import { Grid, useTheme } from '@mui/material'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()(
	(theme, { isLargeScreen }) => ({
		swiperMobileAvecFlecheContainer: {
			position: 'relative',
			height: '100%'
		},
		swiper: {
			overflow: 'hidden',
			margin: 0,

			'& .swiper-wrapper': {
				display: 'inline-flex'
			},
			'& .swiper-pagination': {
				bottom: isLargeScreen ? 12 : 11,
				left: 0,
				height: 'fit-content'
			},
			'& .swiper-pagination-bullet': {
				backgroundColor: WHITE,
				opacity: 0.3,
				height: 5,
				width: 5
			},
			'& .swiper-pagination-bullet-active': {
				opacity: 1
			}
		},
		marginFirstSwiper: {
			height: '100%',
			marginLeft: 0,
			marginRight: 0
		},
		swiperButton: {
			padding: '8px 12px'
		},
		swiperButtonsContainer: {
			position: 'absolute',
			top: '50%',
			zIndex: 1,
			width: 32,
			height: 32,
			background: WHITE,
			borderRadius: 30
		},
		swiperButtonsRightContainer: {
			right: isLargeScreen ? 17 : 10,
			transform: 'translate(0, -50%)'
		},
		swiperButtonsLeftContainer: {
			left: isLargeScreen ? 17 : 10,
			transform: 'translate(0, -50%) rotate(180deg)'
		},
		swiperImg: {
			objectFit: 'cover'
		}
	})
)

interface AcceptingProps {
	photos: Photo[]
}

type SwiperMobileAvecFlechesProps = AcceptingProps

const SwiperMobileAvecFleches: React.FC<SwiperMobileAvecFlechesProps> = (
	{
		photos
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes, cx } = useStyles({ isLargeScreen })
	const theme = useTheme()
	const [swipers, setSwipers] = useState<SwiperComponent[]>([])
	const [hover, setHover] = useState<boolean>(false)
	const [activeSlide, setActiveSlide] = useState<number>(0)

	const firstSwiperClass = cx(
		classes.marginFirstSwiper,
		classes.swiper
	)

	const onButtonClicked = (direction: directionEnum) => {
		if (direction === directionEnum.next) {
			swipers.forEach(swiper => swiper.slideNext())
		} else {
			swipers.forEach(swiper => swiper.slidePrev())
		}
	}

	if (photos.length === 1) {
		return <img src={photos[0].visuel} alt={photos[0].alt} width="100%" height="100%" />
	}

	return (
		<Grid container item xs={12} className={classes.swiperMobileAvecFlecheContainer}>
			<Swiper
				onSwiper={(s: SwiperComponent) => setSwipers((state) => [...state, s])}
				className={firstSwiperClass}
				pagination
				onSlideChange={s => setActiveSlide(s.realIndex)}
			>
				{
					photos.map(
						(photo: Photo, index: number) => (
							<SwiperSlide key={`photo-${index}`}
							             onMouseEnter={() => setHover(true)}
							             onMouseLeave={() => setHover(false)}>
								<img
									src={photo.visuel}
									alt={photo.alt}
									width="100%"
									height="100%"
									className={classes.swiperImg}
								/>
							</SwiperSlide>
						)
					)
				}
			</Swiper>
			{
				(hover || !isLargeScreen) && activeSlide !== 0 &&
				<Grid
					item
					container
					className={
						cx(
							classes.swiperButtonsContainer,
							classes.swiperButtonsLeftContainer
						)
					}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
				>
					<Grid item onClick={() => onButtonClicked(directionEnum.previous)} className={classes.swiperButton}>
						<SvgRightArrowNoBar width={9} height={13} color={theme.palette.blue.main} />
					</Grid>
				</Grid>
			}
			{
				(hover || !isLargeScreen) && activeSlide !== (photos.length - 1) &&
				<Grid
					item
					container
					className={
						cx(
							classes.swiperButtonsContainer,
							classes.swiperButtonsRightContainer
						)
					}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
				>
					<Grid onClick={() => onButtonClicked(directionEnum.next)} className={classes.swiperButton}>
						<SvgRightArrowNoBar width={9} height={13} color={theme.palette.blue.main} />
					</Grid>
				</Grid>
			}
		</Grid>
	)
}

export default SwiperMobileAvecFleches